import { computed, type ComputedRef, inject } from 'vue'

import type { AiUiCrmContext } from '@/stores/aiAssistant/types'

type CrmConfigInject = { value: Record<string, unknown> }

/**
 * Maps App-provided `crmConfigData` into a small snapshot for AI onboarding context.
 */
export function useOnboardingCrmSnapshot(): ComputedRef<AiUiCrmContext | null> {
  const crmConfigInject = inject<CrmConfigInject>('crmConfigData', { value: {} })

  return computed((): AiUiCrmContext | null => {
    const raw = crmConfigInject?.value
    if (raw == null || typeof raw !== 'object') return null
    return {
      crmProvider: raw.crmProvider != null ? String(raw.crmProvider) : null,
      isActive: Boolean(raw.isActive),
      syncModus: raw.syncModus != null ? String(raw.syncModus) : null,
      hasBeenActivated: Boolean(raw.hasBeenActivated),
      isUsedByUser:
        raw.isUsedByUser === true || raw.isUsedByUser === false ? Boolean(raw.isUsedByUser) : null,
      acceptedMasterConnection:
        raw.acceptedMasterConnection === true || raw.acceptedMasterConnection === false
          ? Boolean(raw.acceptedMasterConnection)
          : null,
      enforceMasterConnection:
        raw.enforceMasterConnection === true || raw.enforceMasterConnection === false
          ? Boolean(raw.enforceMasterConnection)
          : null,
    }
  })
}
